/* eslint-disable no-template-curly-in-string */
// Default tokens organized by language (en and es only, no locale variants)
export const defaultTokens = {
    en: {
        programName: 'Program',
        courseName: 'Course',
        documentsName: 'Document', // Legacy alias for documentName.
        documentName: 'Document',
        meetingName: 'Meeting',
        microcastName: 'Microcast',
        lessonName: 'Lesson',
        instructorName: 'Instructor',
        learningBoardName: 'Learning Board',
        startLabel: 'Start ${itemName}',
        continueLabel: 'Continue ${itemName}',
        retakeLabel: 'Retake ${itemName}',
        registerLabel: 'Register',
        acceptInviteLabel: 'Accept Invitation',
        registeredLabel: 'Registered',
        joinMeetingLabel: 'Join Meeting',
        startMeetingLabel: 'Start Meeting',
        noMeetingPermissionsLabel: 'You do not have access to this meeting.',
        viewRecordingLabel: 'View Recording',
        programOutlineLabel: '${programName} Outline',
        programAboutLabel: 'About This ${programName}',
        programDescriptionLabel: '${programName} Description',
        learningObjectivesLabel: 'Learning Objectives',
        instructorsTabLabel: 'Instructors',
        learningBoardMenuItemLabel: '${username}\'s eLearning Board',
        myLearningsLabel: 'My Learnings',
        myMeetingsLabel: 'My Meetings',
        myLearningBoardLabel: 'My ${learningBoardName}',
        myDocumentsLabel: 'My Documents',
        myResultsLabel: 'My Results',
        myAccountLabel: 'My Account',
        signInLabel: 'Sign-in',
        courseDescriptionLabel: '${courseName} Description',
        courseOutlineLabel: '${courseName} Outline',
        courseOverviewLabel: 'Overview',
        courseAboutLabel: 'About This ${courseName} ',
        courseMaterialsLabel: '${courseName} Materials',
        transcriptLabel: 'Transcript',
        qnaLabel: 'Q&A',
        viewLessonLabel: 'View ${lessonName}',
        richText1Label: 'Rich Text 1',
        richText2Label: 'Rich Text 2',
        richText3Label: 'Rich Text 3',
        richText4Label: 'Rich Text 4',
        richText5Label: 'Rich Text 5',
        richText6Label: 'Rich Text 6',
        richText7Label: 'Rich Text 7',
        richText8Label: 'Rich Text 8',
        richText9Label: 'Rich Text 9',
        richText10Label: 'Rich Text 10',
        kickerNameLabel: 'Name',
        kickerEndAtLabel: 'End At Date',
        kickerRichText1Label: 'Rich Text 1',
        kickerRichText2Label: 'Rich Text 2',
        kickerRichText3Label: 'Rich Text 3',
        kickerRichText4Label: 'Rich Text 4',
        kickerRichText5Label: 'Rich Text 5',
        kickerText1Label: 'Text 1',
        kickerText2Label: 'Text 2',
        kickerText3Label: 'Text 3',
        kickerText4Label: 'Text 4',
        kickerText5Label: 'Text 5',
        customerNameLabel: 'Name',
        customerPhoneNumberLabel: 'Phone Number',
        customerText1Label: 'Text 1',
        customerText2Label: 'Text 2',
        customerText3Label: 'Text 3',
        customerText4Label: 'Text 4',
        customerText5Label: 'Text 5',
        discussionGroupLabel: 'Discussion',
        prevLabel: 'PREV',
        nextLabel: 'NEXT',
        startQuizButtonLabel: 'Start Quiz',
        progressLabel: 'Your Progress:',
        notesLabel: 'NOTES',
        addNoteButtonLabel: 'ADD NOTE',
        audioButtonLabel: 'Audio',
        articleButtonLabel: 'Article',
        blockButtonLabel: 'Block',
        certificationButtonLabel: 'Certification',
        courseButtonLabel: 'Course',
        downloadButtonLabel: 'Download',
        knowledgeCheckButtonLabel: 'Knowledge Check',
        microcastButtonLabel: 'Microcast',
        pdfButtonLabel: 'PDF',
        quizButtonLabel: 'Quiz',
        scormButtonLabel: 'Scorm',
        videoButtonLabel: 'Video',
        typeformButtonLabel: 'Typeform',
        htmlButtonLabel: 'Info',
        seeMoreText: 'see more',
        seeLessText: 'see less',
        aiSearchToggleOffText: 'Turn off AI Search',
        aiSearchToggleOnText: 'Turn on AI Search',
        // Converse UI tokens
        resetConversationLabel: 'New Conversation',
        submitRefinementsLabel: 'Submit Refinements',
        promptPlaceholder: 'How can I help?',
        startingMessage: 'What can I help you find today?',
        suggestedPrompts: '',
        persistentPrompts: '',
        productPromptHeader: 'Have questions about this product?',
        categoryPromptHeader: 'Have questions about this collection?',
        pageSuggestedPromptsHeader: '',
        smartSummaryHeader: 'Key Product Features',
        categorySmartSummaryHeader: 'Key Collection Highlights',
        generatedByAiLabel: 'Generated by AI',
        serviceUnavailableMessage: 'Service Temporarily Unavailable.',
        // Commerce Card tokens
        commerceCardNoAccessButtonLabel: 'Learn More',
        commerceCardWithAccessButtonLabel: 'Start Course',
        commerceLandingPageNoAccessButtonLabel: 'Learn More',
        commerceLandingPageWithAccessButtonLabel: 'Start Course',
        // Open Support Tool tokens
        openSupportToolMessage: 'Please give us a moment while we transfer you...',
        openSupportToolOffHoursMessage: 'We are currently closed. Please contact us during our business hours.',
        // Product button tokens
        addToBagLabel: 'Add to Bag',
        addedToCartLabel: 'Added to Cart',
        soldOutLabel: 'Sold Out',
        addingLabel: 'Adding...',
        selectAllOptionsLabel: 'Please select all options',
        checkoutLabel: 'Checkout',
        viewDetailsLabel: 'View details',
    },
    es: {
        programName: 'Programa',
        courseName: 'Curso',
        documentsName: 'Documento', // Legacy alias for documentName.
        documentName: 'Documento',
        meetingName: 'Reunión',
        microcastName: 'Microcast',
        lessonName: 'Lección',
        instructorName: 'Instructor',
        learningBoardName: 'Tablero de Aprendizaje',
        startLabel: 'Iniciar ${itemName}',
        continueLabel: 'Continuar ${itemName}',
        retakeLabel: 'Reintentar ${itemName}',
        registerLabel: 'Registrarse',
        acceptInviteLabel: 'Aceptar Invitación',
        registeredLabel: 'Registrado',
        joinMeetingLabel: 'Unirse a la Reunión',
        startMeetingLabel: 'Iniciar Reunión',
        noMeetingPermissionsLabel: 'No tienes acceso a esta reunión.',
        viewRecordingLabel: 'Ver Grabación',
        programOutlineLabel: 'Contenido de ${programName}',
        programAboutLabel: 'Acerca de este ${programName}',
        programDescriptionLabel: 'Descripción de ${programName}',
        learningObjectivesLabel: 'Objetivos de Aprendizaje',
        instructorsTabLabel: 'Instructores',
        learningBoardMenuItemLabel: 'Tablero de Aprendizaje de ${username}',
        myLearningsLabel: 'Mis Aprendizajes',
        myMeetingsLabel: 'Mis Reuniones',
        myLearningBoardLabel: 'Mi ${learningBoardName}',
        myDocumentsLabel: 'Mis Documentos',
        myResultsLabel: 'Mis Resultados',
        myAccountLabel: 'Mi Cuenta',
        signInLabel: 'Iniciar Sesión',
        courseDescriptionLabel: 'Descripción de ${courseName}',
        courseOutlineLabel: 'Contenido de ${courseName}',
        courseOverviewLabel: 'Resumen',
        courseAboutLabel: 'Acerca de este ${courseName}',
        courseMaterialsLabel: 'Materiales de ${courseName}',
        transcriptLabel: 'Transcripción',
        qnaLabel: 'Preguntas y Respuestas',
        viewLessonLabel: 'Ver ${lessonName}',
        richText1Label: 'Rich Text 1',
        richText2Label: 'Rich Text 2',
        richText3Label: 'Rich Text 3',
        richText4Label: 'Rich Text 4',
        richText5Label: 'Rich Text 5',
        richText6Label: 'Rich Text 6',
        richText7Label: 'Rich Text 7',
        richText8Label: 'Rich Text 8',
        richText9Label: 'Rich Text 9',
        richText10Label: 'Rich Text 10',
        kickerNameLabel: 'Nombre',
        kickerEndAtLabel: 'Fecha de Finalización',
        kickerRichText1Label: 'Rich Text 1',
        kickerRichText2Label: 'Rich Text 2',
        kickerRichText3Label: 'Rich Text 3',
        kickerRichText4Label: 'Rich Text 4',
        kickerRichText5Label: 'Rich Text 5',
        kickerText1Label: 'Texto 1',
        kickerText2Label: 'Texto 2',
        kickerText3Label: 'Texto 3',
        kickerText4Label: 'Texto 4',
        kickerText5Label: 'Texto 5',
        customerNameLabel: 'Nombre',
        customerPhoneNumberLabel: 'Número de Teléfono',
        customerText1Label: 'Texto 1',
        customerText2Label: 'Texto 2',
        customerText3Label: 'Texto 3',
        customerText4Label: 'Texto 4',
        customerText5Label: 'Texto 5',
        discussionGroupLabel: 'Discusión',
        prevLabel: 'ANTERIOR',
        nextLabel: 'SIGUIENTE',
        startQuizButtonLabel: 'Iniciar Cuestionario',
        progressLabel: 'Tu Progreso:',
        notesLabel: 'NOTAS',
        addNoteButtonLabel: 'AGREGAR NOTA',
        audioButtonLabel: 'Audio',
        articleButtonLabel: 'Artículo',
        blockButtonLabel: 'Bloque',
        certificationButtonLabel: 'Certificación',
        courseButtonLabel: 'Curso',
        downloadButtonLabel: 'Descargar',
        knowledgeCheckButtonLabel: 'Prueba de conocimientos',
        microcastButtonLabel: 'Microcast',
        pdfButtonLabel: 'PDF',
        quizButtonLabel: 'Cuestionario',
        scormButtonLabel: 'Scorm',
        videoButtonLabel: 'Video',
        typeformButtonLabel: 'Typeform',
        htmlButtonLabel: 'Información',
        seeMoreText: 'ver más',
        seeLessText: 'ver menos',
        aiSearchToggleOffText: 'Desactivar búsqueda con IA',
        aiSearchToggleOnText: 'Activar búsqueda con IA',
        // Converse UI tokens
        resetConversationLabel: 'Nueva Conversación',
        submitRefinementsLabel: 'Enviar Refinamientos',
        promptPlaceholder: '¿En qué puedo ayudarte?',
        startingMessage: '¿En qué puedo ayudarte hoy?',
        suggestedPrompts: '',
        persistentPrompts: '',
        productPromptHeader: '¿Tienes preguntas sobre este producto?',
        categoryPromptHeader: '¿Tienes preguntas sobre esta colección?',
        pageSuggestedPromptsHeader: '',
        smartSummaryHeader: 'Características principales del producto',
        categorySmartSummaryHeader: 'Aspectos destacados de la colección',
        generatedByAiLabel: 'Generado por IA',
        serviceUnavailableMessage: 'Servicio Temporalmente No Disponible.',
        // Commerce Card tokens
        commerceCardNoAccessButtonLabel: 'Saber Más',
        commerceCardWithAccessButtonLabel: 'Comenzar Curso',
        commerceLandingPageNoAccessButtonLabel: 'Saber Más',
        commerceLandingPageWithAccessButtonLabel: 'Comenzar Curso',
        // Open Support Tool tokens
        openSupportToolMessage: 'Por favor espera un momento mientras te transferimos...',
        openSupportToolOffHoursMessage: 'Actualmente estamos cerrados. Por favor contáctanos durante nuestro horario de atención.',
        // Product button tokens
        addToBagLabel: 'Agregar al Carrito',
        addedToCartLabel: 'Agregado al Carrito',
        soldOutLabel: 'Agotado',
        addingLabel: 'Agregando...',
        selectAllOptionsLabel: 'Por favor selecciona todas las opciones',
        checkoutLabel: 'Finalizar Compra',
        viewDetailsLabel: 'Ver detalle',
    },
};
/**
 * Detects if tokens structure is legacy (flat) or new (multi-locale)
 */
function isLegacyStructure(tokens) {
    if (!tokens || typeof tokens !== 'object' || Array.isArray(tokens)) {
        return false;
    }
    const keys = Object.keys(tokens);
    if (keys.length === 0) {
        return false;
    }
    return keys.every((key) => {
        const value = tokens[key];
        return value === null || value === undefined || typeof value === 'string';
    });
}
/**
 * Extracts language code from locale (e.g., 'en-GB' -> 'en')
 */
function getLanguageFromLocale(locale) {
    return locale.split('-')[0];
}
class Tokens {
    constructor(portal) {
        /**
         * Sets the locale for token resolution
         * @param locale - Locale to use for token resolution
         */
        this.setLocale = (locale) => {
            this.locale = locale;
        };
        /**
         * Resolves token value with multi-locale support and backward compatibility
         * @param key - Token key to resolve
         * @param locale - Optional locale override (defaults to Tokens.locale or portal.defaultLocale)
         * @returns Resolved token value or placeholder {{key}}
         */
        this.getValue = (key, locale) => {
            const tokens = this.portal?.tokens;
            const isLegacy = isLegacyStructure(tokens);
            // Determine active locale: explicit param > Tokens.locale > portal.defaultLocale > 'en'
            const activeLocale = locale
                || this.locale
                || this.portal?.defaultLocale
                || 'en';
            const language = getLanguageFromLocale(activeLocale);
            // Legacy structure: flat tokens
            if (isLegacy) {
                // Check portal tokens first
                if (tokens && typeof tokens === 'object' && key in tokens) {
                    return tokens[key];
                }
                // Fallback to defaults for the requested language
                if (defaultTokens[language] && key in defaultTokens[language]) {
                    return defaultTokens[language][key];
                }
                // Fallback to English defaults
                if (language !== 'en' && defaultTokens.en && key in defaultTokens.en) {
                    return defaultTokens.en[key];
                }
                // Placeholder as last resort
                return `{{${key}}}`;
            }
            // Multi-locale structure
            if (tokens && typeof tokens === 'object') {
                // 1. Try activeLocale (e.g., 'en-GB')
                if (activeLocale in tokens && tokens[activeLocale] && typeof tokens[activeLocale] === 'object') {
                    const localeTokens = tokens[activeLocale];
                    if (key in localeTokens) {
                        return localeTokens[key];
                    }
                }
                // 2. Try language fallback (e.g., 'en-GB' -> 'en')
                if (activeLocale !== language && language in tokens && tokens[language] && typeof tokens[language] === 'object') {
                    const langTokens = tokens[language];
                    if (key in langTokens) {
                        return langTokens[key];
                    }
                }
            }
            // 3. Fallback to defaultTokens[language]
            if (defaultTokens[language] && key in defaultTokens[language]) {
                return defaultTokens[language][key];
            }
            // 4. Fallback to English defaults if language not found
            if (language !== 'en' && defaultTokens.en && key in defaultTokens.en) {
                return defaultTokens.en[key];
            }
            // 5. Placeholder as last resort
            return `{{${key}}}`;
        };
        /**
         * Resolves a portal text field with token fallback
         * @param portalValue - Value from portal field (can be string, null, undefined, or empty)
         * @param tokenKey - Token key to use for fallback
         * @returns Resolved text value
         */
        this.resolvePortalText = (portalValue, tokenKey) => {
            if (portalValue && typeof portalValue === 'string' && portalValue.trim()) {
                return portalValue;
            }
            return this.getValue(tokenKey);
        };
        this.format = (template, variables) => {
            let s = template;
            Object.keys(variables).forEach((key) => {
                const re = new RegExp(`\\\${${key}}`, 'gm');
                s = s.replace(re, variables[key]);
            });
            // make this more general
            ['courseName', 'courseName/plural', 'programName', 'programName/plural', 'learningBoardName', 'learningBoardName/plural', 'microcastName', 'microcastName/plural', 'lessonName', 'lessonName/plural'].forEach((key) => {
                const re = new RegExp(`\\\${${key}}`, 'gm');
                s = s.replace(re, this.getValue(key));
            });
            return s;
        };
        this.portal = portal;
    }
    getToken(code, variables) {
        try {
            const parts = code.split('/');
            const key = parts[0];
            const modifiers = parts.slice(1);
            let value = this.getValue(key);
            value = this.format(value, variables || {});
            if (modifiers.indexOf('plural') >= 0) {
                return `${value}s`;
            }
            return value;
        }
        catch (e) {
            console.log(`Error getting ${code}`, e);
            return `{{${code}}}`;
        }
    }
}
export default Tokens;
//# sourceMappingURL=Tokens.js.map